import { render, staticRenderFns } from "./formAccount.vue?vue&type=template&id=3131e780&scoped=true"
import script from "./formAccount.vue?vue&type=script&lang=js"
export * from "./formAccount.vue?vue&type=script&lang=js"
import style0 from "./formAccount.vue?vue&type=style&index=0&id=3131e780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3131e780",
  null
  
)

export default component.exports